const en = {
  title: 'Payment Page',
  subtitle: '',
  status: {
    successTitle: 'Payment completed',
    successDescriptionPrefix: '',
    failedTitle: 'Payment declined',
    failedDescriptionPrefix: '',
    awaitingTitle: 'Awaiting additional data',
    awaitingDescription: 'The universal flow requires extra fields before we can continue.',
    formTitleFallback: 'Provide the required data',
    redirectTitle: 'Redirecting…',
    redirectDescription: 'If the page does not open automatically, use the button below.',
    redirectButton: 'Open page',
    infoTitleFallback: 'Payment information',
    infoButton: 'Continue',
    pendingTitle: 'Processing',
    pendingDescription: 'Waiting for a provider response. You can refresh the status manually.',
    refreshButton: 'Refresh status',
    refreshBusy: 'Refreshing…',
    checkAgain: 'Check again',
    tryAgain: 'Try again',
    infoBusy: 'Processing…',
    redirectLinkAction: 'Return to service site'
  },
  infoDetails: {
    account_name: 'Account name',
    account_number: 'Account number',
    bank_code: 'Bank code',
    bank_name: 'Bank name',
    expiry_date_in_utc: 'Expiry date (UTC)',
    provider_name: 'Provider',
    merchant_name: 'Merchant',
    payment_method: 'Payment method',
    transaction_type: 'Transaction type'
  },
  order: {
    heading: 'Order details',
    primaryLabel: 'Order ID',
    secondaryLabel: 'Order ID 2',
    providerLabel: 'Provider',
    merchantLabel: 'Merchant',
    paymentMethodLabel: 'Payment method',
    transactionTypeLabel: 'Transaction type',
    transactionLabel: 'Transaction ID',
    transactionRefLabel: 'Transaction reference',
    amountLabel: 'Amount',
    currencyLabel: 'Currency',
    statusToggleShow: 'Show status',
    statusToggleHide: 'Hide status',
    transactionTypes: {
      '4': 'Refund / Chargeback',
      '15': 'SBP refund',
      '16': 'Payout',
      '17': 'Deposit'
    },
    paymentMethods: {
      '0': 'T-Money',
      '1': 'M-PESA',
      '2': 'Airtel',
      '3': 'Orange Money',
      '4': 'Afrimoney',
      '5': 'MTN',
      '6': 'Zamtel',
      '7': 'Lumicash',
      '8': 'Bank transfer',
      '9': 'Bank card',
      '10': 'Simulator',
      '11': 'Avada Cash',
      '12': 'Tigo',
      '13': 'Vodafone',
      '15': 'Equitel',
      '16': 'Snapscan',
      '17': 'Ozow',
      '18': 'HaloPesa',
      '19': 'Mobile Money Cameroon',
      '20': 'Mobile Money Burkina Faso',
      '21': 'Mobile Money Ivory Coast',
      '22': 'Mobile Money Zambia',
      '23': 'E-Money',
      '24': 'Free Money',
      '25': 'T-Kash',
      '26': 'Expresso',
      '27': 'Buddy',
      '28': 'Mobile Money Rwanda',
      '29': 'Dalapay Cash',
      '30': 'Wave',
      '31': 'Vodacom',
      '33': 'TOGOCOM',
      '34': 'MOOV Money',
      '35': 'Mobicash',
      '36': 'Pay Attitude',
      '37': 'OPay',
      '38': 'Palmpay',
      '39': 'AzamPesa',
      '40': 'Celtiis',
      '41': 'Agents Network',
      '42': 'Cellulant',
      '43': 'Etisalat',
      '44': 'Instapay',
      '45': 'CIB Smart Wallet',
      '46': 'Voucher',
      '47': 'TNM',
      '48': 'EU Mobile',
      '49': 'Youmee',
      '50': 'Yas',
      '51': 'Baridi',
      '52': 'Nagad',
      '53': 'bKash',
      '54': 'EasyPaisa',
      '55': 'JazzCash',
      '56': 'BM Wallet',
      '57': 'Fawry',
      '58': 'Wepay',
      '59': 'EazyPesa',
      '60': 'T-Pesa',
      '61': 'Telcom',
      '62': 'Zeepay',
      '63': 'Biat',
      '64': 'Flouci',
      '65': 'D17',
      '66': 'Tikmoney Cash'
    }
  },
  statusBanner: {
    resultTitle: 'Result code',
    providerTitle: 'Provider response'
  },
  form: {
    submit: 'Continue',
    selectPlaceholder: 'Select…',
    validationFallback: 'Please fill this field',
    pending: 'Please fill this field',
    invalidFormat: 'Please enter a valid value',
    processing: 'Processing…',
    /** Legend: map from backend legend text to translated text (key = value from API) */
    formLegendTranslations: {
      'Please enter customer full name (will be used for account name and customer details)': 'Please enter customer full name (will be used for account name and customer details)',
      'Please enter customer email address': 'Please enter customer email address',
      'Customer full name': 'Customer full name',
      'Customer email address': 'Customer email address'
    },
    /** Description: map from backend description text to translated text (key = value from API) */
    formDescriptionTranslations: {
      'Customer full name': 'Customer full name',
      'Customer email address': 'Customer email address'
    }
  },
  error: {
    title: 'Error',
    summary: 'We could not process the request.',
    showDetails: 'Show technical details',
    hideDetails: 'Hide technical details',
    retry: 'Try again',
    retrying: 'Trying again…'
  }
} as const;

export default en;
